import React from 'react';

export const Separator: React.FC = () => {
  return <hr />;
};
